document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {
      loop: true,
      buttons: ["zoom", "slideShow", "fullScreen", "close"],
      Thumbs: {
        autoStart: false
      }
    });
  });